export enum BatchBoardingStatus {
  INITIALIZING = 'INITIALIZING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum BatchBoardingUploadType {
  MANUAL = 'MANUAL',
  FILE = 'FILE',
  AUTO_ONBOARDING = 'AUTO_ONBOARDING',
}
